import { Col, Row } from 'antd';
/**
 * 
 * @returns 
 */
export const BaseBox = ({ height = undefined, children }) => {
  return (
    <Row className="component-box" style={{ height : height || ''  }}>
      <Col span={24}>
        {children}
      </Col>
    </Row>
  );
};
